import { render, staticRenderFns } from "./bibliometric.vue?vue&type=template&id=e68f428a&scoped=true&"
import script from "./bibliometric.vue?vue&type=script&lang=js&"
export * from "./bibliometric.vue?vue&type=script&lang=js&"
import style0 from "./bibliometric.vue?vue&type=style&index=0&id=e68f428a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68f428a",
  null
  
)

export default component.exports